/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CityDto
 */
export interface CityDto {
    /**
     * City ID
     * @type {number}
     * @memberof CityDto
     */
    id: number;
    /**
     * City name
     * @type {string}
     * @memberof CityDto
     */
    name: string;
    /**
     * City latitude
     * @type {string}
     * @memberof CityDto
     */
    latitude: string;
    /**
     * City longitude
     * @type {string}
     * @memberof CityDto
     */
    longitude: string;
}

/**
 * Check if a given object implements the CityDto interface.
 */
export function instanceOfCityDto(value: object): value is CityDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    return true;
}

export function CityDtoFromJSON(json: any): CityDto {
    return CityDtoFromJSONTyped(json, false);
}

export function CityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
    };
}

export function CityDtoToJSON(json: any): CityDto {
    return CityDtoToJSONTyped(json, false);
}

export function CityDtoToJSONTyped(value?: CityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}

